module.exports = __webpack_public_path__ + "static/img/Framemin.edcaf55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Framemin.png
// module id = PFwo
// module chunks = 1